if (!customElements.get('lambretta-products-carousel')) {
  class LambrettaProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.main-list-collections__carousel-viewport');
      this.track = this.querySelector('.main-list-collections__carousel-track');
      const row = this.closest('.main-list-collections__category-row');
      this.prevButton = row?.querySelector('[data-carousel-direction="previous"]');
      this.nextButton = row?.querySelector('[data-carousel-direction="next"]');
      this.slides = Array.from(this.track.children);

      if (!this.viewport || !this.track || this.slides.length < 2) {
        this.classList.add('is-static');
        this.updateButtons();
        return;
      }

      this.onScroll = this.onScroll.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onResize = this.onResize.bind(this);

      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);

      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.measure();
      this.updateButtons();
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    measure() {
      if (!this.slides.length) return;

      const trackStyles = getComputedStyle(this.track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      this.slideStep = this.slides[0].offsetWidth + gap;
      this.slidesPerView = Math.max(
        1,
        Math.round((this.viewport.clientWidth + gap) / this.slideStep)
      );
      this.maxScroll = Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
    }

    onResize() {
      this.measure();
      this.updateButtons();
    }

    onScroll() {
      window.clearTimeout(this.scrollTimeout);
      this.scrollTimeout = window.setTimeout(() => this.updateButtons(), 80);
    }

    scrollByStep(direction) {
      if (!this.slideStep) return;

      const behavior = this.prefersReducedMotion?.matches ? 'auto' : 'smooth';
      const stepCount = this.slidesPerView || 1;
      this.viewport.scrollBy({
        left: direction * this.slideStep * stepCount,
        behavior,
      });
    }

    onPrev(event) {
      event.preventDefault();
      this.scrollByStep(-1);
    }

    onNext(event) {
      event.preventDefault();
      this.scrollByStep(1);
    }

    updateButtons() {
      if (!this.prevButton || !this.nextButton) return;

      const scrollLeft = this.viewport?.scrollLeft || 0;
      const atStart = scrollLeft <= 4;
      const atEnd = scrollLeft >= this.maxScroll - 4;

      this.prevButton.disabled = atStart;
      this.nextButton.disabled = atEnd;
    }
  }

  customElements.define('lambretta-products-carousel', LambrettaProductsCarousel);
}
